import { RestQueryHookOptions, RestQueryHookResult, useRestQuery } from 'utils/hooks/api';

const CALENDAR_CAMPAIGNS_URL = '/i/calendar/campaigns';

export interface CampaignEvent {
  id: number;
  start: number;
  end: number;
  url: string;
  title: string;
  campaignState: string;
  sendSize: number;
  class: string;
}

export const useGetCampaignsCalendarQuery = (
  options?: RestQueryHookOptions,
): RestQueryHookResult<CampaignEvent[]> => {
  return useRestQuery<CampaignEvent[]>(CALENDAR_CAMPAIGNS_URL, {}, options);
};
